
import {Component, Vue} from 'vue-property-decorator';
import {Game, JDR, Character} from '@/types/Interfaces';
import {createCharacter} from '@/types/CharacterTemplates';
import {onValue, ref, remove, set} from 'firebase/database';
import {db} from '@/firebase';
import {supabase} from '@/supabase';

@Component
export default class EditPage extends Vue {
    game: Game | null = null;

    ParceDomine: JDR = JDR.ParceDomine;
    files: string[] = [];
    currentMap = '';

    async changeCategory(): Promise<void> {
        await set(ref(db, `/jdrs/${this.$route.params.gameId}`), this.game);
    }

    async created(): Promise<void> {
        try {
            const jdrsRef = ref(db, `/jdrs/${this.$route.params.gameId}`);
            onValue(jdrsRef, (snapshot) => {
                this.game = snapshot.val();
                if (this.game && this.game.map) this.currentMap = this.game.map;
                if (this.game && this.files.length === 0) {
                    supabase.storage.from('LaFabrique').list(`${this.$route.params.gameId}/maps`).then(({ data }) => {
                        this.files = data?.map(f => f.name) ?? [];
                    }).catch((error: unknown) => {
                        console.error(error);
                    });
                }
            });
            
        } catch (error) {
            console.error('error : ' + error);
        }
    }

    async updateCharacter(character: Character): Promise<void> {
        await set(ref(db, `/jdrs/${this.$route.params.gameId}/characters/${character.playerId}`), character);
    }

    characterName = '';
    isNPC = true;
    playerId = '';

    addCharacter(): void {
        if (!this.game) return;
        const obj = createCharacter(this.game.type, this.characterName, this.playerId, this.game.id, this.isNPC);
        if (!obj) {
            console.error('Error: can\'t create character');
            return;
        }
        if (this.isNPC) {
            obj.playerId = `${this.game.npcCount}`;
            set(ref(db, `/jdrs/${this.game.id}/npcCount`), this.game.npcCount + 1);
        }
        set(ref(db, `/jdrs/${this.game.id}/characters/${obj.playerId}`), obj);
    }

    changeMap(): void {
        if (this.game) {
            this.game.map = this.currentMap;
            set(ref(db, `/jdrs/${this.$route.params.gameId}`), this.game);
        }
    }

    deleteMap(): void {
        if (this.game) {
            const mapToDelete = this.currentMap;
            supabase.storage.from('LaFabrique').remove([`${this.game.id}/maps/${mapToDelete}`]).then(() => {
                this.files = this.files.filter(f => f !== mapToDelete);
                this.currentMap = "";
                if (this.game) this.game.map = "";
                set(ref(db, `/jdrs/${this.$route.params.gameId}`), this.game);
            }).catch(() => {
                console.error(`failed to delete map ${mapToDelete}`);
            })
        }
    }

    image: any;

    setFile(event: any): void {
        this.image = event.target.files[0];
    }

    async upload(): Promise<void> {
        if (this.game) {
            const span = document.getElementById('validation-text');
            supabase.storage.from('LaFabrique').upload(`${this.game.id}/maps/${this.image.name}`, this.image, { upsert: true }).then(() => {
                this.files.push(this.image.name);
                if (span) span.textContent = 'Uploaded !';
            }).catch((error: unknown) => {
                if (span) span.textContent = 'Error : ' + error;
            });
        }
    }

    groupInput = '';

    async addGroup(): Promise<void> {
        if (this.game) {
            if (this.game.groups) {
                if (this.game.groups.includes(this.groupInput)) return;
                this.game.groups.push(this.groupInput);
            } else {
                this.game.groups = [this.groupInput];
            }
            set(ref(db, `/jdrs/${this.$route.params.gameId}`), this.game);
        }
    }

    modalDelete = false;
    modalDeleteText = '';
    modalDeleteCharacter: Character | undefined = undefined;

    deletePNJ(character: Character): void {
        this.modalDelete = true;
        this.modalDeleteText = character.name;
        this.modalDeleteCharacter = character;
    }

    async confirmDeleteCharacter(): Promise<void> {
        if (this.game && this.modalDeleteCharacter) {
            this.modalDelete = false;
            await remove(ref(db, `/jdrs/${this.game.id}/characters/${this.modalDeleteCharacter.playerId}`));
        }
    }

    modalDeleteGroup = false;
    modalDeleteGroupText = '';

    deleteGroup(group: string): void {
        this.modalDeleteGroup = true;
        this.modalDeleteGroupText = group;
    }

    async confirmDeleteGroup(): Promise<void> {
        if (this.game) {
            this.modalDelete = false;
            const groups = this.game.groups.filter(g => g !== this.modalDeleteGroupText);
            for (const character of Object.values(this.game.characters)) {
                if (this.game && character.category === this.modalDeleteGroupText) {
                    character.category = '';
                    await set(ref(db, `/jdrs/${this.game.id}/characters/${character.playerId}`), character);
                }
            }
            await set(ref(db, `/jdrs/${this.game.id}/groups`), groups);
            this.modalDeleteGroup = false;
        }
    }

}
